import { CSSProperties, ReactNode } from "react";

export interface InfoProps {
  title: string | ReactNode;
  titleStyle?: CSSProperties;
  info: string | ReactNode;
  infoStyle?: CSSProperties;
}
export default function Info({ info, title, infoStyle, titleStyle }: InfoProps) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
      <div style={titleStyle || { color: "#A6AAB0", fontSize: 14 }}>{title}</div>
      <div style={infoStyle || { color: "#393F47", fontSize: 14 }}>{info}</div>
    </div>
  );
}
